import styles from "./FieldSection.module.css"

function FieldSection({ label, dado }) {
    return (
        <div className={styles.containerField}>
            <label>{label}</label>
            <p>{dado}</p>
        </div>
    )
}

export default FieldSection;